import React from 'react';
import { Link } from 'react-router-dom';
export const TechnologyLinksSection = () => {
  const technologies = ['Laravel', 'Vue.js', 'React', 'PHP', 'Tailwind CSS', 'Livewire', 'Alpine.js', 'Inertia.js', 'MySQL', 'Redis', 'AWS', 'Docker'];
  return <div className="flex flex-wrap justify-center gap-4" data-id="element-133">
      {technologies.map(tech => <Link key={tech} to={`/developers?skill=${tech}`} className="px-6 py-3 bg-[#1a1d24] border border-gray-700 rounded-full text-gray-300 hover:text-white hover:border-[#d73b3e] hover:bg-[#d73b3e]/10 transition-all duration-300 text-sm font-medium" data-id="element-134">
          {tech}
        </Link>)}
    </div>;
};